import React from 'react'

function Employers() {
  return (
    <div style={{ border:'40px solid #3d5a80', justifyContent:'center', alignItems:'center',display:'flex', height:'80vh', flexDirection:'column'}}>
      Employers data
    </div>
  )
}

export default Employers
